import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";
import { Appointment } from "../AppointmentCardsContainer/types";

interface CheckIsCanCheckInParams {
  appointment: Appointment | null;
  role?: DatabaseEnum["center_user_role"];
}

const checkIsCanCheckIn = ({
  appointment,
  role,
}: CheckIsCanCheckInParams): boolean => {
  return !!(
    appointment &&
    role &&
    ["intake_complete", "confirmed"].includes(appointment.status)
  );
  // TODO: uncomment this when forms issue is resolved
  // && ["technologist", "super_admin", "regional_admin", "receptionist"].includes(
  //   role,
};

export default checkIsCanCheckIn;
